// extracted by mini-css-extract-plugin
export var basicImageContainer = "index-module--basicImageContainer--it-V-";
export var constraint = "index-module--constraint--PpudI";